import {toISODate, toInt} from "../../../../utils/convert-fields"
import {formatDateBr} from "../../../../utils/convert-fields"

export const premioFields = [
    {"key": "IDEventoPremio", "label": "ID Evento Prêmio"},
    {"key": "DataReferencia", "label": "Data Referência"},
    {"key": "DataEvento", "label": "Data Evento"},
    {"key": "DataLiquidacao", "label": "Data Liquidação"},
    {"key": "ValorPremio", "label": "Valor Prêmio"},
    {"key": "TipoPremio", "label": "Tipo Prêmio"},
    {"key": "FormulaPremio", "label": "Fórmula Prêmio"},
    {"key": "CalculoPremio", "label": "Cálculo Prêmio"},
    {"key": "CasasPremio", "label": "Casas Prêmio"},
]

export const mapPremioPayload = (
    tableData = [],
    cetip,
    versaoDocumento,
    idCaracteristica
) => {
    return tableData
        .filter(column =>
            column &&
            Object.keys(column).length > 0 &&
            Object.values(column).some(v => v !== "" && v !== null && v !== undefined)
        )
        .map((column) => ({
            RendaFixaCaracteristicasID: idCaracteristica,
            IDPremio: toInt(column.IDPremio) ?? null,
            CETIP: cetip,
            VersaoDocumento: toInt(versaoDocumento),
            DataReferencia: toISODate(column.DataReferencia),
            DataPremio: toISODate(column.DataPremio),
            ValorPremio: column.ValorPremio ?? "",
            IDEventoPremio: column.IDEventoPremio ?? "",
            TipoPremio: column.TipoPremio ?? "",
            CalculoPremio: column.CalculoPremio ?? "",
            CasasPremio: column.CasasPremio ?? "",
        }))
}

export const mapPremioToTable = (apiData = []) => {
    if (!apiData || apiData.length === 0) return [{}]

    return apiData.map(item => ({
        ID: item.ID,
        IDPremio: item.IDPremio ?? "",
        DataReferencia: item.DataReferencia ? formatDateBr(item.DataReferencia) : "",
        CETIP: item.CETIP || "",
        VersaoDocumento: item.VersaoDocumento ?? "",
        DataPremio: item.DataPremio ? formatDateBr(item.DataPremio) : "",
        ValorPremio: item.ValorPremio ?? "",
        IDEventoPremio: item.IDEventoPremio ?? "",
        TipoPremio: item.TipoPremio ?? "",
        CalculoPremio: item.CalculoPremio ?? "",
        CasasPremio: item.CasasPremio ?? "",
    }))
}